export const booleanOrUndefined = (value?: boolean | string): boolean | undefined => {
  if (value === true || value === 'true') {
    return true
  }
  if (value === false || value === 'false') {
    return false
  }
  return undefined
}
